"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { FacebookShareButton, FacebookIcon, LinkedinShareButton, LinkedinIcon, TwitterShareButton, XIcon } from "react-share";

// This does this isMounted check to get around a hydration issue.
function ShareSection(t0) {
  const $ = _c(7);
  const {
    classNames
  } = t0;
  const [isMounted, setIsMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isMounted) {
    return null;
  }
  if (typeof window === "undefined") {
    return null;
  }
  const shareUrl = window.location.href;
  const t3 = `social-section ${classNames || ""}`;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FacebookShareButton url={shareUrl} htmlTitle="Share on Facebook" className="ml-0 mr-[6px] lg:mr-0 lg:ml-[12px]"><FacebookIcon size={26} round={true} bgStyle={{
        fill: "transparent"
      }} className="rounded-full border-dotted border-1 border-(--color-blue-trmb)" iconFillColor="#0063a3" /></FacebookShareButton>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TwitterShareButton url={shareUrl} htmlTitle="Share on X" className="ml-0 mr-[6px] lg:mr-0 lg:ml-[12px]"><XIcon size={26} round={true} bgStyle={{
        fill: "transparent"
      }} className="rounded-full border-dotted border-1 border-(--color-blue-trmb)" iconFillColor="#0063a3" /></TwitterShareButton>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LinkedinShareButton url={shareUrl} htmlTitle="Share on LinkedIn" className="ml-0 mr-[6px] lg:mr-0 lg:ml-[12px]"><LinkedinIcon size={26} round={true} bgStyle={{
        fill: "transparent"
      }} className="rounded-full border-dotted border-1 border-(--color-blue-trmb)" iconFillColor="#0063a3" /></LinkedinShareButton>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t3) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[5] = t3;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}
export default ShareSection;